/********************************************
* Custom cursor
********************************************/
function fnCursor() {
    return;

    var

        // Cursors
        oCursor = $('#custom-cursor'),
        oCursorMain = $('span.main', oCursor),
        oCursorFollow = $('span.follow', oCursor),
        oCursorProgress = $('svg', oCursor),

        // Hover zones
        oHoverDefaultAnchor = $('[data-cursor="reg"], .cursor--reg, .fancybox-container, ol.flickity-page-dots li.dot, .flickity-prev-next-button, section.article-content .textarea a, input[type="checkbox"], .ui-slider-handle'),
        oHoverMenu = $('[data-cursor="menu"], .cursor--menu, #menu-header-menu li a'),
        oHoverPrimaryButton = $('[data-cursor="primary-button"], .cursor--primary-btn, .button-bordered, .button-bordered-white'),
        oHoverImage = $('[data-cursor="image"], .cursor--image'),
        oHoverView = $('[data-cursor="view"], .cursor--view'),
        oDragView = $('[data-cursor="drag"], .cursor--drag'),
        oHoverStickyMenuItem = $('#full-screen-menu .sector-item, .projects-filter a'),

        // Statuses
        bInitCursor = false,
        bDefaultCursorPos = true

        ;

    // Disable standard cursor
    if ($(window).width() > 1230) {
        $('a').mouseover(function () { $(this).css({ cursor: 'none' }); });
    }

    /**
    * Detect mouse movement
    */
    $(document).mousemove(function (event) {

        // Enable cursor
        fnInitCursor();

        // Store current mouse coordinates
        var iMousePosY = event.clientY,
            iMousePosX = event.clientX;

        // Pass mouse coordinates
        fnMoveCursor(iMousePosY, iMousePosX);

    });

    /**
    * Update cursor position
    */
    function fnMoveCursor(iMousePosY, iMousePosX) {

        // Pass new CSS values into array
        var aNewPosition = {
            top: iMousePosY + 'px',
            left: iMousePosX + 'px'
        };

        // Apply CSS array to cursors
        oCursorMain.css(aNewPosition);
        oCursorProgress.css(aNewPosition);

        if (bDefaultCursorPos) {
            oCursorFollow.css(aNewPosition);
        }

    }

    /**
    * Initial cursor
    */
    function fnInitCursor() {

        if (!bInitCursor) {
            oCursor.css('opacity', 1);
            bInitCursor = true;
        }

    }

    /**
    * Restore default cursor position
    */
    function fnRestoreDefaultPosition(sClassToRemove) {

        // Remove styling class
        if (sClassToRemove) {
            oCursor.removeClass(sClassToRemove);
        }

        // Set default cursor position
        bDefaultCursorPos = true;

    }

    /**
    * Restore default cursor position
    */
    function fnRemoveCustomClasses() {

        oCursor.removeClass();

    }

    /**
    * Mouse leave window (hidden from view)
    */
    $(window).on('mouseout', function (event) {

        oCursor.css('opacity', 0);
        bInitCursor = false;

    });

    /***************
    * Loop hover zones (anchors)
    ***************/

    /**
    * Standard anchor
    */
    $.each([oHoverDefaultAnchor], function (index) {

        var sClass = 'hover--standard';

        $(this).on({

            mouseenter: function (event) {

                // Remove classes
                fnRemoveCustomClasses();

                // Apply CSS array to cursors
                oCursor.addClass(sClass);

            },

            mouseleave: function (event) {

                // Restore default cursor position
                fnRestoreDefaultPosition(sClass);

            }

        });

    });

    /**
    * Primary button
    */
    $.each([oHoverPrimaryButton], function (index) {

        var sClass = 'hover--primary-btn',
            oButton = $(this);

        $(this).on({

            mouseenter: function (event) {

                // Remove classes
                fnRemoveCustomClasses();

                // Disable default cursor position
                bDefaultCursorPos = false;

                // Get top/left positions of hovered item
                var iWindowTop = $(window).scrollTop(),
                    iPositionTop = $(this).offset().top - iWindowTop,
                    iPositionLeft = $(this).offset().left;

                // Pass new CSS values into array
                var aNewPosition = {
                    top: (iPositionTop + 25) + 'px',
                    left: (iPositionLeft + 2) + 'px'
                };

                // Apply CSS array to cursors
                oCursorFollow.css(aNewPosition);

                // Apply additional class if button is white
                if ($(this).hasClass('button--white')) {
                    oCursor.addClass('white');
                }

                // Apply CSS array to cursors
                oCursor.addClass(sClass);

            },

            mouseleave: function (event) {

                // Restore default cursor position
                fnRestoreDefaultPosition(sClass);

                // Remove additional class if button is white
                if ($(this).hasClass('button--white')) {
                    oCursor.removeClass('white');
                }

            }

        });

    });

    /**
     * Menu
     */
    $.each([oHoverMenu], function (index) {

        var sClass = 'hover--menu';

        $(this).on({

            mouseenter: function (event) {

                // Remove classes
                fnRemoveCustomClasses();

                // Apply CSS array to cursors
                oCursor.addClass(sClass);

            },

            mouseleave: function (event) {

                // Restore default cursor position
                fnRestoreDefaultPosition(sClass);

            }

        });

    });

    /**
    * Image
    */
    $.each([oHoverImage], function (index) {

        var sClass = 'hover--image';

        $(this).on({

            mouseenter: function (event) {

                // Remove classes
                fnRemoveCustomClasses();

                // Apply CSS array to cursors
                oCursor.addClass(sClass);

            },

            mouseleave: function (event) {

                // Restore default cursor position
                fnRestoreDefaultPosition(sClass);

            }

        });

    });


    /**
    * View
    */
    $.each([oHoverView], function (index) {

        var sClass = 'hover--view';

        $(this).on({

            mouseenter: function (event) {

                // Remove classes
                fnRemoveCustomClasses();

                // Apply CSS array to cursors
                oCursor.addClass(sClass);

                // Apply additional class if button is white
                if ($(this).closest('.cursor--view').hasClass('cursor--view--white')) {
                    oCursor.addClass('white');
                }

            },

            mouseleave: function (event) {

                // Update class var to include colour options (for removal)
                sClass = 'hover--view white';

                // Restore default cursor position
                fnRestoreDefaultPosition(sClass);

            }

        });

    });

    /**
    * Drag
    */
    $.each([oDragView], function (index) {

        var sClass = 'hover--drag';

        $(this).on({

            mouseenter: function (event) {

                // Remove classes
                fnRemoveCustomClasses();

                // Apply CSS array to cursors
                oCursor.addClass(sClass);

                // Apply additional class if button is white
                if ($(this).closest('.cursor--drag').hasClass('cursor--drag--white')) {
                    oCursor.addClass('white');
                }

            },

            mouseleave: function (event) {

                // Update class var to include colour options (for removal)
                sClass = 'hover--drag white';

                // Restore default cursor position
                fnRestoreDefaultPosition(sClass);

            }

        });

    });

    /**
    * Sticky menu items
    */
    $.each([oHoverStickyMenuItem], function (index) {

        var sClass = 'hover--sticky-menu';

        $(this).on({

            mouseenter: function (event) {

                // Remove classes
                fnRemoveCustomClasses();

                // Disable default cursor position
                bDefaultCursorPos = false;

                // Get top/left positions of hovered item
                var iWindowTop = $(window).scrollTop(),
                    iPositionTop = $(this).offset().top - iWindowTop,
                    iPositionLeft = $(this).offset().left;

                // Pass new CSS values into array
                if ($(this).closest("section.projects-slider").length > 0) {
                    var aNewPosition = {
                        top: (iPositionTop + 6) + 'px',
                        left: (iPositionLeft - 15) + 'px'
                    };
                    sClass = 'hover--sticky-menu-light';
                } else {
                    var aNewPosition = {
                        top: (iPositionTop + 17) + 'px',
                        left: (iPositionLeft - 12) + 'px'
                    };
                }

                // Apply CSS array to cursors
                oCursorFollow.css(aNewPosition);

                // Apply class for styling
                oCursor.addClass(sClass);

            },

            mouseleave: function (event) {

                // Restore default cursor position
                fnRestoreDefaultPosition(sClass);

            }

        });

    });


}


// END OF DOCUMENT
